import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

import { doc } from 'selectors/common'
import attachmentsActions from 'actions/attachmentsActions'

let select = (state, props) => ({
	attachment: doc(state, props.attachmentID)
})
let avatarStyle ={
	width: "32px"
  , height: "32px"
  , overflow: "hidden"
  , borderRadius: "100%"
  , display: "inline-block"
}
export class AttachmentCard extends Component {
	render() {
		let { props } = this
		let regex = /(png|jpg|jpeg|bmp|gif)$/i;
		return(
			(props.attachment && !props.attachment.retries)?
				<div style={{display: "inherit"}}>
					{props.avatar?
						<img
							src={props.attachment.url}
							style={props.avatarStyle || avatarStyle}
						/>
						:
						<a
							href={props.attachment.url}
							target="_blank"
							style={{display: "inline-block", margin: "10px 5px 0 5px"}}
							title={props.attachment.name}
							>
							{
								(!props.attachment.url.match(regex))?
									<span
										style={{
											cursor: "pointer"
										  , width:"50px"
										  , display: "block"
										}}
									>
										{props.attachment.name.slice(props.attachment.name.lastIndexOf('.') + 1).toUpperCase()}
									</span>
									:
									<img
										src={props.attachment.url}
										style={{width: "50px"}}
									/>
							}
						</a>
					}

					{
						(props.removable)?

							<IconMenu
								iconButtonElement={
									<i
										className="material-icons delete-attachment-icon"
										style={{height: "15px"}}
									>
										clear
									</i>
								}
								onChange={(evt, value) => {
									(value == "delete")? props.ATTACHMENT_DELETE(props.attachmentID) : ""
								}}
								anchorOrigin={{horizontal: 'left', vertical: 'top'}}
								targetOrigin={{horizontal: 'left', vertical: 'top'}}
							>
								<MenuItem primaryText="Delete" value="delete"/>
								<MenuItem primaryText="Cancel" value="cancel"/>
							</IconMenu>
							:
							""
					}
				</div>
				:
				<img src={".." + "/static/img/loader.gif"} style={{width:"30px", height: "30px"}}/>
		)
	}
}
export default connect(select, attachmentsActions)(AttachmentCard)



// WEBPACK FOOTER //
// ./src/components/Attachments/AttachmentCard.js